import { requestWithToken } from '../utilities/request';
const path = '/api/private/progress';

/**
 * 会社の工種テンプレート一覧情報を取得する。
 * @param {string}fieldId
 * @param {object}params
 * */
const getProgressListWorkTypeTemplates = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/fields/${fieldId}/work_type_templates`),
    params,
  });
};

/**
 * 会社の大工種一覧を取得する。
 * @param {string}fieldId
 * @param {object}params
 * */
const getProgressListMainWorkTypes = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/fields/${fieldId}/main_work_types`),
    params,
  });
};

/**
 * 現場で使用している大・小工種を変更する。
 * @param {string}fieldId
 * @param {object}data
 * */
const updateProgressFieldWorkTypes = (fieldId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/fields/${fieldId}/field_work_types`),
    data,
  });
};

/**
 * 進捗歩掛で登録している大工種を取得する
 * @param {string}fieldId
 * @param {object}params
 * */
const getProgressFieldMainWorkTypes = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/fields/${fieldId}/field_main_work_types`),
    params,
  });
};

/**
 * 進捗歩掛で登録している小工種を取得する
 * @param {string}fieldId
 * @param {object}params
 * */
const getProgressFieldSubWorkTypes = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/fields/${fieldId}/field_sub_work_types`),
    params,
  });
};

/**
 * 進捗歩掛現場設定情報を更新する
 * @param {string}fieldId
 * */
const getProgressFieldSettings = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/fields/${fieldId}/progress_field_settings`),
  });
};

/**
 * @param {string}fieldId
 * @param {object}data
 * */
const updateProgressOrderFieldWorkTypes = (fieldId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/fields/${fieldId}/field_work_types/order_numbers`),
    data,
  });
};

/**
 * 進捗歩掛で登録している工種を取得する
 * @param {string}fieldId
 * @param {object}params
 * */
const getProgressWorkTypeSettings = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/fields/${fieldId}/progress_work_type_settings`),
    params,
  });
};

/**
 * 進捗・歩掛で使用工種を更新する
 * @param {string}fieldId
 * @param {object}data
 * */
const updateProgressWorkTypeSettings = (fieldId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/fields/${fieldId}/progress_work_type_settings`),
    data,
  });
};

/**
 * 工種軸の進捗・歩掛一覧情報を返す
 * @param {string}fieldId
 * @param {object}params
 * */
const getProgressSchedulesAxisByWorkType = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/fields/${fieldId}/progress_schedules/work_type_axis_by_work_type`
    ),
    params,
  });
};

/**
 * バッチの実行状態を返す
 * @param {string}fieldId
 * */
const getProgressAggregateHistories = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/fields/${fieldId}/progress_aggregate_histories`),
  });
};

/**
 * バッチの実施を呼び出すAPI（手動バッチ）
 * @param {string}fieldId
 * */
const updateProgressBatch = fieldId => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/fields/${fieldId}/batch`),
  });
};

/**
 * 進捗・歩掛の入力期間情報を更新する
 * @param {string}fieldId
 * @param {object}data
 * */
const updateProgressFieldSettings = (fieldId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/fields/${fieldId}/progress_field_settings`),
    data,
  });
};

/**
 * 進捗・歩掛計画一覧情報を更新する
 * @param {string}fieldId
 * @param {object}data
 * */
const updateProgressSchedulesBulkUpdate = (fieldId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/fields/${fieldId}/progress_schedules/bulk_update`),
    data,
  });
};

/**
 * 進捗・歩掛計画集計情報を取得する
 * @param {string}fieldId
 * @param {object}params
 * @param {number}id
 * */
const getProgressScheduleDetail = (fieldId, params, id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/fields/${fieldId}/progress_schedules/${id}/aggregate_result`
    ),
    params,
  });
};

/**
 * 進捗・歩掛計画カレンダー情報を取得する
 * @param {string}fieldId
 * @param {object}params
 * */
const getProgressScheduleCalendars = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/fields/${fieldId}/progress_schedule_calendars`),
    params,
  });
};

/**
 * get progress field work type BS006
 * @param {string}fieldId
 * @param {object}params
 * */
const getProgressFieldWorkTypes = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/fields/${fieldId}/field_work_types`),
    params,
  });
};

export const ProgressService = {
  getProgressListWorkTypeTemplates,
  getProgressListMainWorkTypes,
  updateProgressFieldWorkTypes,
  getProgressFieldMainWorkTypes,
  getProgressFieldSubWorkTypes,
  getProgressFieldSettings,
  updateProgressOrderFieldWorkTypes,
  getProgressWorkTypeSettings,
  updateProgressWorkTypeSettings,
  getProgressSchedulesAxisByWorkType,
  getProgressAggregateHistories,
  updateProgressBatch,
  updateProgressFieldSettings,
  updateProgressSchedulesBulkUpdate,
  getProgressScheduleDetail,
  getProgressScheduleCalendars,
  getProgressFieldWorkTypes,
};

export default ProgressService;



// WEBPACK FOOTER //
// ./src/services/Progress.js